import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import ButtonPrimary from '../../../Components/subcomponents/ButtonPrimary';
import currentDomain from "../../../Utils/Utils";

function Judgedashboard({ goToBallot, judge_uuid, setSelectedCar, isAdmin }) {
  const { handleSubmit } = useForm({
    mode: 'onChange',
  });

  const [display, setDisplay] = useState('');

  const lookupCar = (num) => {
    return new Promise((resolve, reject) => {
      fetch(`${currentDomain(location)}/api/entries/${num}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        switch (response.status) {
          case 200:
            response.json().then((data) => {
              console.log('Car found:', data);
              resolve(data);
            })
              .catch((e) => { reject(500) });
            break;
          case 404:
            reject(404);
            break;
          default:
            console.log('Error:', response.status);
            reject(500);
        }
      }).catch((e) => { reject(500) })

    })
  };

  const canJudge = (car) => {
    return new Promise((resolve, reject) => {
      fetch(`${currentDomain(location)}/api/ballot/${car.uuid}`, {
        method: 'GET'
      }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            console.log(judge_uuid)
            console.log(car)
            console.log("See above")
            if (judge_uuid === data[i].judge_uuid) {
              alert("You have already judged this vehicle. If this is a mistake, please contact Brady.")
              resolve(false)
            }
          }

          if (data.length > 1) {
            if (isAdmin) {
              alert("This vehicle has already been judged enough. Do you want to judge it again?")
              resolve(true)
            }
            else {
              alert("This vehicle has already been judged enough. Try a different one!")
              resolve(false)
            }
          }
          
          resolve(true)
        }).catch((e) => { reject(500) })
      }).catch((e) => { reject(500)});
    })
  }

  // Handle number click
  const handleClick = (value) => {
    setDisplay((prevDisplay) => prevDisplay + value);
  };

  // Handle delete (backspace)
  const handleDelete = () => {
    setDisplay((prevDisplay) => prevDisplay.slice(0, -1));
  };

  // Handle clear (clear all)
  const handleClear = () => {
    setDisplay('');
  };

  // Handle form submission
  const onSubmit = () => {
    if (display === '') {
      toast.error('Enter a car number first.');
      return;
    }

    lookupCar(display)
      .then((car) => {
        // Store the entered value using the setEnteredNumber function
        setSelectedCar(car);

        canJudge(car)
          .then((canJudge) => {
            if (!canJudge) {
              setDisplay('');
              return;
            }
            goToBallot();
          })
          .catch((e) => {
            toast.error('Could not check this car\'s ballots. Please try again.');
          });



      })
      .catch((e) => {
        if (e === 404) {
          toast.error(`Car #${display} not found. Double-check the number on the dash card.`);
        }
        else {
          toast.error('Error looking up car. Please try again.');
        }
      })
  };

  return (
    <div className="flex flex-col items-center justify-center px-8">
      <div className="w-full max-w-md pt-8">
        {/* Title */}
        <h1 className="text-2xl font-bold mb-4 text-center">Enter Car Registration Number</h1>

        {/* Display */}
        <div className="mb-4 flex items-center justify-between border p-4">
          <div className="text-3xl font-semibold">{display}</div>
          <button
            onClick={handleClear}
            className="bg-gray-300 hover:bg-gray-400 text-black font-bold py-2 px-4 rounded"
          >
            Clear
          </button>
        </div>

        {/* Numpad */}
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
            <button
              key={num}
              onClick={() => handleClick(num)}
              className="bg-gray-100 hover:bg-gray-200 text-black font-bold py-4 px-4 rounded-md text-2xl"
            >
              {num}
            </button>
          ))}
          <button
            onClick={handleDelete}
            className="bg-red-100 hover:bg-red-200 text-black font-bold py-4 px-4 rounded-md text-2xl"
          >
            ←
          </button>
          <button
            onClick={() => handleClick(0)}
            className="bg-gray-100 hover:bg-gray-200 text-black font-bold py-4 px-4 rounded-md text-2xl"
          >
            0
          </button>
        </div>

        {/* Start Ballot Button */}
        <div className="py-12 flex justify-center">
          <ButtonPrimary onClick={handleSubmit(onSubmit)}>Go to Ballot</ButtonPrimary>
        </div>
      </div>
    </div>

  );
}

export default Judgedashboard;
